class Search {
    constructor(form) {
        this.form = form;
        this.init();
    }
  
    init() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();

            const query = this.buildQuery();
            const baseUrl = this.form.action.split('?')[0];
            const newUrl = `${baseUrl}?${query}`;

            window.location.href = newUrl;
        });
    }
  
    buildQuery() {
        const formData = new FormData(this.form);
        const params = new URLSearchParams();
    
        const checkboxGroups = {};
    
        for (let [key, value] of formData.entries()) {
            const input = this.form.querySelector(`[name="${key}"]`);
    
            if (input && input.type === 'checkbox') {
                // Group checkbox values under the same key
                if (!checkboxGroups[key]) {
                    checkboxGroups[key] = [];
                }
                checkboxGroups[key].push(value);
            } else {
                // Handle normal input types (text, select, etc.)
                params.set(key, value);
            }
        }
  
        // Add checkbox groups to the query
        for (let key in checkboxGroups) {
            params.set(key, checkboxGroups[key].join(','));
        }
  
        return params.toString();
    }
}

export default Search;